import { Auth0Provider } from '@auth0/auth0-react'
import { HelixProvider, ToastProvider } from '@helix-ds/react'
import React from 'react'
import { Provider } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'
import Layout from './components/Layout'
import ScrollToTop from './components/ScrollToTop'
import auth0Config from './features/auth/auth0/config/auth0'
import AuthGuard from './features/auth/components/AuthGuard'
import DevAuthBypassProvider from './features/auth/components/DevAuthBypassProvider'
import Login from './features/auth/components/Login'
import LoginCallback from './features/auth/components/LoginCallback'
import SentryUserSync from './features/auth/components/SentryUserSync'
import { isDevAuthBypassActive } from './features/auth/devBypass'
import HarnessPage from './features/viewers/igv/HarnessPage'
import AnalysisSamplesPage from './pages/AnalysisSamplesPage'
import BenchmarkViewerPage from './pages/BenchmarkViewerPage'
import CasePage from './pages/CasePage'
import Home from './pages/Home'
import NotFound from './pages/NotFound'
import OrderCasePage from './pages/OrderCasePage'
import OrderViewerPage from './pages/OrderViewerPage'
import ViewerPage from './pages/ViewerPage'
import { store } from './store'

const AuthShell: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (isDevAuthBypassActive()) {
    return <DevAuthBypassProvider>{children}</DevAuthBypassProvider>
  }
  return <Auth0Provider {...auth0Config}>{children}</Auth0Provider>
}

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <HelixProvider>
        <AuthShell>
          <SentryUserSync />
          <ScrollToTop />
          <ToastProvider>
            <Routes>
              <Route path="/health" element={<div>Health check successful</div>} />

              <Route path="/login" element={<Login />} />
              <Route path="/login/callback" element={<LoginCallback />} />

              <Route
                path="/"
                element={
                  <AuthGuard>
                    <Layout />
                  </AuthGuard>
                }
              >
                <Route index element={<Navigate to="/home" replace />} />
                <Route path="home" element={<Home />} />
                <Route path="cases/:caseId" element={<CasePage />} />
                <Route path="analyses/:token" element={<AnalysisSamplesPage />} />
                <Route path="orders/:token" element={<OrderCasePage />} />
                <Route path="orders/:token/tracks-only" element={<OrderViewerPage />} />
                <Route path="benchmarks/:setId/:sampleDir" element={<BenchmarkViewerPage />} />
                <Route path="viewers/igv/harness" element={<HarnessPage />} />
                <Route path="viewers/:viewerId/:variantId" element={<ViewerPage />} />
                <Route path="*" element={<NotFound />} />
              </Route>
            </Routes>
          </ToastProvider>
        </AuthShell>
      </HelixProvider>
    </Provider>
  )
}

export default App
